import React from 'react';
import styled from 'styled-components';

export const PaginateItem = (props: {
  className?: string;
  children: React.ReactNode;
}) => (
  <StyledPaginateItem className={props.className}>
    {props.children}
  </StyledPaginateItem>
);
const StyledPaginateItem = styled.li`
  display: inline-block;
  border: 1px solid var(--COLOR_GALLERY);
  font-weight: bold;
  font-size: 16px;
  background: var(--COLOR_WHITE);
  &.active {
    background: var(--COLOR_LUCKY_POINT);
    border-color: transparent;
    span {
      color: var(--COLOR_WHITE);
    }
  }
  a,
  span {
    color: inherit;
    padding: 0.5em 0.75em;
    display: block;
    text-decoration: none;
  }
  a:hover {
    background: color-mix(in srgb, var(--COLOR_LUCKY_POINT) 20%, white);
  }
  span {
    color: var(--COLOR_ALTO);
  }
`;
